import React from "react";
const LanguageContext: any = React.createContext("en");
export default LanguageContext;
